module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [(_vm.name && _vm.hideName === false) ? _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": _vm.uniqueId
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('label.' + _vm.name)) + " "), (_vm.crequired) ? _c('small', [_vm._v("*")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', [_c('input', {
    staticClass: "form-control",
    class: {
      'is-danger': _vm.errors.length > 0
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.cplaceholder,
      "id": _vm.uniqueId
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.$emit('input', $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors), function(error) {
    return _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.length > 0),
        expression: "errors.length > 0"
      }],
      staticClass: "help is-danger"
    }, [_vm._v(_vm._s(error))])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-60b87214!./~/vue-loader/lib/selector.js?type=template&index=0!./~/htmlhint-loader?{"configFile":".htmlhintrc.json","failOnError":true}!./src/components/base/f-input.vue
// module id = 657
// module chunks = 1